import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "bootstrap/dist/css/bootstrap.css";

import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

import "./index.css";

ReactDOM.render(<App />, document.getElementById("root"));
